import { getTranslate } from 'legacy-src/utilities/i18n'
import Markdown from 'markdown-to-jsx'

import { ButtonLink } from '@/legacy-src/components/ui/button'

import useTherapists from '../../hooks/useTherapists'
import TherapistBubbles from '../TherapistBubbles'

/* mock states */
enum State {
  notActive = 'notActive',
  active = 'active',
  activeWithBenefit = 'activeWithBenefit',
}

type Props = {
  readonly state?: string
}

const CounsellingBannerInactive: React.FC<Props> = ({ state = State.notActive }) => {
  const { t } = getTranslate()
  const { therapists } = useTherapists('all')

  return (
    <div className="mx-auto mb-10 flex max-w-[800px] grow flex-row justify-center rounded-xl bg-white px-10 py-8 text-center text-base">
      <div>
        <Markdown>{t(`component.counseling.banner.priceInfo`)}</Markdown>
        <div>
          <div className="flex flex-row justify-center">
            <TherapistBubbles {...{ therapists }} />
          </div>
          <div className="text-text-color">
            {state === State.notActive && <Markdown>{t(`component.counseling.banner.desc`)}</Markdown>}
            {state === State.active && <Markdown>{t(`component.counseling.banner.descActive`)}</Markdown>}
            {state === State.activeWithBenefit && (
              <Markdown>{t(`component.counseling.banner.descActiveBenefit`)}</Markdown>
            )}
          </div>

          <ButtonLink href={'/counselling'} className="my-6">
            {t('component.counseling.startChat.button')}
          </ButtonLink>
        </div>
      </div>
    </div>
  )
}

export default CounsellingBannerInactive
